import { api } from './api';

export type FeedKind = 'google_news' | 'rss' | 'api' | 'serp_trends' | 'mos';
export type ProcMode = '1x1' | 'multi_fonte' | 'enriquecer' | 'dados';
export type Mode = 'auto' | 'semi' | 'off';
export type Estado = 'no_ar' | 'migrar' | 'nova';

export interface Editoria {
  slug: string;
  nome: string;
  estado: Estado;
  modo: Mode;
  ordem: number;
  feed: {
    kind: FeedKind;
    fonte: string;
    query?: string; // termo de busca (google_news)
    url?: string; // URL do feed (rss) ou tópico pré-configurado
    itens: number;
    intervalo: string;
  };
  proc: { mode: ProcMode; modelo: string; dedup: boolean };
  pub: {
    sites: string[];
    categoria: string;
    categoria_id?: number;
    autor: string;
    status: 'publish' | 'draft';
    porHora: number;
  };
  flags: string[];
}

export type EditoriaPatch = Partial<Omit<Editoria, 'slug'>>;

export interface IngestResult {
  slug: string;
  total: number;
  novos: number;
  duplicados: number;
  dedup: boolean;
  itens: { titulo: string; url: string; novo: boolean }[];
}

export interface RunResult {
  slug: string;
  gerado: boolean;
  motivo?: string;
  dry_run?: boolean;
  mode?: string;
  modelo?: string;
  custo_usd?: number;
  texto_fonte?: string;
  fontes?: { titulo: string; url: string }[];
  titulo?: string;
  html?: string;
  status_destino?: string;
  wp_id?: number;
  wp_link?: string;
}

export const editoriasApi = {
  list: (): Promise<Editoria[]> => api.get<Editoria[]>('/editorias'),
  get: (slug: string): Promise<Editoria> => api.get<Editoria>(`/editorias/${slug}`),
  patch: (slug: string, patch: EditoriaPatch): Promise<Editoria> =>
    api.put<Editoria>(`/editorias/${slug}`, patch),
  ingest: (slug: string): Promise<IngestResult> =>
    api.post<IngestResult>(`/editorias/${slug}/ingest`),
  run: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=true`),
  publish: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=false`),
  publishLive: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=false&publish=true`),
};
